<template>
  <div class="results-section-container">
    <results-section-display-bar
      :target-engine="targetEngine"
      @handleCopyClick="$emit('handleCopyClick', $event)"
      @newTabResults="$emit('newTabResults')"
      @reloadResults="$emit('reloadResults')"
    />
    <div id="div-results-section">
      <span class="notch notch-top-left"></span>
      <span class="notch notch-top-right"></span>
      <div class="section-container" v-if="showResultsComponent">
        <iframe v-if="targetEngine.showIFrameResults" class="uxl-results-frame" :src='resultsUrl'></iframe>
        <v-card-text v-else class="tds-no-section-results">
          <div class="open-in-new-cta-container" @click="$emit('newTabResults')">
            <span class="open-in-new-cta-text">View Results</span>
            <v-icon class="open-in-new-cta-icon">open_in_new</v-icon>
          </div>
          <span class="open-in-new-text-container">
            <i18n path="results.newTabMsgHeading" class="open-in-new-text-heading">
              <template v-slot:sourceTitle>
                <span class="open-in-new-source-container" @click="$emit('newTabResults')">
                  <img :src="targetEngine.imgUrl" alt="source logo" class="open-in-new-source-img">
                  <span>{{ targetEngine.name }}</span>
                </span>
              </template>
            </i18n><br />
            <span class="open-in-new-text-subtitle">{{ $t('results.newTabMsgSubheading') }}</span>
          </span>
        </v-card-text>
      </div>
      <div class="section-container" v-else-if="this.$store.state.appState.showAIComponent">
        <SearchAIContainer />
      </div>
      <div id="div-results-rhs" v-show="lhsDragging"></div>
    </div>
    <results-section-message-bar :show-polyglot-queries="showPolyglotQueries" @handleSearchAIClick="handleSearchAIClick"></results-section-message-bar>
  </div>
</template>

<script>
import ResultsSectionDisplayBar from './ResultsSectionDisplayBar'
import ResultsSectionMessageBar from './ResultsSectionMessageBar'
import SearchAI from '../SearchAI.vue'
import SearchAIContainer from '../searchAi/SearchAIContainer.vue'
import '../../../style/_variables.scss'

export default {
  name: 'results-iframe',
  components: {ResultsSectionDisplayBar, SearchAI, SearchAIContainer, ResultsSectionMessageBar},
  props: ['targetEngine', 'lhsDragging', 'booleanString', 'divResultsWidth', 'queryMessages'],
  computed: {
    showResultsComponent: { get () { return this.$store.state.appState.showResultsComponent } },
    showingAITab: { get () { return this.$store.state.appState.showAIComponent } },
    showAIComponent: { get () { return this.$store.state.appState.showAIComponent } },
    resultsUrl: { get () { return this.$store.state.queryState.resultsUrl } },
    showPolyglotQueries: { get () { return this.targetEngine.showPolyglotQueries } },
    generateQueryCheck: { get () { return this.$store.getters.getContentGenerated } },
    finalSearchQuery: { get () { return this.$store.getters.getFinalSearchQuery } }
  },
  data () {
    return {
      displayResults: true,
      displayGenerator: false
    }
  },
  methods: {
    toggleDisplays (changeTo) {
      switch (changeTo) {
        case 'results':
          this.displayResults = true
          this.displayGenerator = false
          break
        case 'generator':
          this.displayGenerator = true
          this.displayResults = false
      }
    },
    handleSearchAIClick () {
      this.$store.dispatch('handleSearchAIClick')
    }
  },
  watch: {
    showingAITab: function (val) {
      if (val) {
        this.toggleDisplays('generator')
      } else {
        this.toggleDisplays('results')
      }
    },
    generateQueryCheck: function (val) {
      if (val) {
        this.$emit('launchGeneratorQuery', [this.finalSearchQuery, 'polyglot'])
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.results-section-container {
  position: relative;
  height: 100%;
}
.open-in-new-cta {
  &-container {
    border: 2px solid $black-900;
    border-radius: $length-med-s;
    width: fit-content;
    margin-bottom: $length-med-l;
    padding: $length-med-s;
    cursor: pointer;
    justify-self: center;
    display: flex;
    align-items: center;
    &:hover {
      box-shadow: 0 0 0 4px $grey-500;
    }
  }
  &-text {
    font-size: $length-med-m;
  }
  &-icon {
    font-size: $length-large-xs;
    margin-left: 10px;
  }
}
.open-in-new-cta {
  &-container {
    border: 2px solid $blue-primary;
    border-radius: $length-med-s;
    width: fit-content;
    margin-bottom: $length-med-xl;
    padding: $length-med-s;
    cursor: pointer;
    justify-self: center;
    display: flex;
    align-items: center;
    &:hover {
      box-shadow: 0 0 0 4px $grey-500;
    }
  }
  &-text {
    font-size: $length-med-m;
  }
  &-icon {
    color: $blue-primary;
    font-size: $length-large-xs;
    margin-left: 10px;
  }
}
.result-links {
  &-container {
    display: flex;
    padding: 10px 15px;
    position: relative;
    background-color: $grey-400;
  }
  &-url {
    margin-right: 12px;
    max-width: 33%;
  }
  &-query-string {
    flex-grow: 1;
    &-title-container {
      display: flex;
    }
  }
  &-title {
    font-weight: bold;
  }
  &-subtitle {
    padding-left: .4rem;
  }
  &-text {
    overflow: hidden;
    height: 1.5rem;
    &-error-msg {
      font-style: italic;
    }
  }
  &-syntax-guide {
    text-decoration: underline;
    flex-grow: 1;
    text-align: right;
    padding-right: 25px;
    color: $blue-primary;
  }
  &-box {
    border: 1px solid $black-700;
    border-radius: 10px;
    padding-left: 10px;
    display: flex;
    justify-content: space-between;
  }
  &-btn {
    background-color: $grey-500;
    border-radius: 0 10px 10px 0;
    margin-left: 5px;
    & > i {
      font-size: 14px;
      padding: 0 3px;
    }
  }
}

.tds-no-section-results {
  margin-top: $length-large-m;
  display: grid;
  place-content: center;
  &-button {
    width: fit-content;
    justify-self: center;
  }
}
.section-container {
  height: 100%;
}
#div-results-section {
  height: calc(100% - #{$results-section-display-bar-height} - #{$results-section-message-bar-min-height});
  width: 100%;
  float: left;
  background-color: $bg-primary;
}
#div-results-section iframe {
  height: 100%;
  width: 100%;
  border: none;
}
.open-in-new {
  &-icon {
    color: $blue-primary;
    border: 2px solid $blue-primary;
    border-radius: $length-med-s;
    width: $length-large-s;
    aspect-ratio: 1;
    margin-bottom: $length-med-l;
    font-size: $length-large-xs;
    &:hover {
      box-shadow: 0 0 0 4px $grey-500;
    }
  }
  &-source {
    &-container {
      background-color: $light-blue-400;
      border-radius: $length-small-xl;
      padding: $length-med-s;
      cursor: pointer;
    }
    &-img {
      position: relative;
      top: 10px;
      max-width: 35px;
      max-height: 35px;
    }
  }
  &-text {
    &-container {
      text-align: center;
    }
    &-heading {
      font-size: $font-size-large;
      line-height: 2.5;
    }
    &-subtitle {
      font-size: $font-size-med;
    }
  }
}
#div-results-rhs {
  position: absolute;
  top: 0;
  left: $length-small-xl;
  height: 100%;
  width: calc(100% - .75rem);
  z-index: 400;
}

.notch {
  position: absolute;
  width: 25px;
  aspect-ratio: 1;
  background: $grey-400;
  z-index: 1;
  // @todo - this is best way to create the outer of a quater circle shape
  --mask: radial-gradient(25px at 0 100%,#0000 98%,#000);
  -webkit-mask: var(--mask);
  mask: var(--mask);
  &-top-left {
    top: 55px;
    left: 0;
    transform: rotate(-90deg);
  }
  &-top-right {
    top: 55px;
    right: 0;
  }
}

#notch-bottom-left {
  position: absolute;
  width: 25px;
  aspect-ratio: 1;
  background: $grey-400;
  bottom: -25px;
  right: 0;
  z-index: 1;
  // @todo - this is best way to create the outer of a quater circle shape
  --mask: radial-gradient(25px at 0 100%,#0000 98%,#000);
  -webkit-mask: var(--mask);
  mask: var(--mask);
}

</style>



// WEBPACK FOOTER //
// src/components/parts/ResultsContainer/ResultsIframe.vue